import React from 'react'
import { useAbTestGtm } from '../../../../hooks/useAbTestGtm'
import styles from './ScoutNotification.module.css'

const ScoutNotification = () => {
    const { dataViewLabel, dataClickLabel } = useAbTestGtm()

    return (
        <div className={styles.container} data-view-label={dataViewLabel('CT_Scout')}>
            <div 
            className={styles.contentWrapper}
            style={{ backgroundImage: 'url(/pages/google/ScountNotification/background.png)' }}
        >
            <div className={styles.content}>
                    <div className={styles.headerSection}>
                      <img 
                        src='/pages/google/ScountNotification/4.png' 
                        alt='登録するだけでスカウトが届く' 
                        className={styles.headerImage}
                      />
                    </div>

                    <div className={styles.scoutCardSection}>
                      <img 
                        src='/pages/google/ScountNotification/1.png'
                        alt='スカウト通知カード' 
                        className={styles.scoutCardImage}
                      />
                    </div>

                    <div className={styles.speechSection}>
                      <img 
                        src='/pages/google/ScountNotification/2.png' 
                        alt='企業からのメッセージ' 
                        className={styles.speechImage}
                      />
                    </div>

                    <div className={styles.aitaiSection}>
                      <img 
                        src='/pages/google/ScountNotification/3.png' 
                        alt='あいたい通知セクション' 
                        className={styles.aitaiImage}
                      />
                    </div>

                    <div className={styles.ctaSection}>
                      <button 
                        className={styles.ctaButton}
                        data-click-label={dataClickLabel('CT_Scout_CTAボタン')}
                        onClick={() => {
                            window.location.href = '/signup?channel=googleadwords&p=3&ctaId=2'
                        }}
                      >
                        スカウト/あいたいを受け取る
                      </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ScoutNotification